import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../features/auth/contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { isAuthenticated, initialized, user, isLoading } = useAuth();
  const location = useLocation();

  // Save the intended admin route when we start checking
  useEffect(() => {
    if (!isAuthenticated && initialized && !isLoading) {
      sessionStorage.setItem('adminRedirectPath', location.pathname);
    }
  }, [isAuthenticated, initialized, isLoading, location.pathname]);

  if (!initialized || isLoading) {
    return <LoadingSpinner overlay message="Checking admin permissions..." />;
  }

  if (!isAuthenticated || !user) {
    // Save intended path and redirect to home
    sessionStorage.setItem('adminRedirectPath', location.pathname);
    return <Navigate to="/" replace />;
  }

  // Check if user has admin role
  const isAdmin = user.roles?.some(role =>
    ['ADMIN', 'SUPER_ADMIN', 'MODERATOR', 'ANALYST'].includes(role.toUpperCase())
  ) || user.username === 'admin' || user.username === 'alex';

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;